import { render, staticRenderFns } from "./shenhe.vue?vue&type=template&id=d58bacb4&scoped=true&"
import script from "./shenhe.vue?vue&type=script&lang=js&"
export * from "./shenhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58bacb4",
  null
  
)

export default component.exports